import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import ArticleCard from '@/components/base/ArticleCard';
import { articles, categories } from '@/mocks/articles';

const featuredArticles = articles.filter((a) => a.featured);
const recentArticles = articles.filter((a) => !a.featured);

const categoryMap: Record<string, string> = {};
categories.forEach((c) => {
  categoryMap[c.slug] = c.name;
});

const faqItems = [
  {
    question: '「羊宫妃那我来草你了」是什么意思？',
    answer: '这是中文二次元社区中一句流行网络用语，结合了对日本声优羊宫妃那（Yomiya Hina）的喜爱和粉丝文化中特有的表达方式。它并非字面攻击性言论，而是一种带有调侃和追捧意味的「整活」行为，体现了粉丝对声优的狂热喜爱和二次元社区独特的语言创造力。',
  },
  {
    question: '羊宫妃那是谁？',
    answer: '羊宫妃那（Yomiya Hina）是日本新生代声优，出生于2000年3月26日，隶属于青二Production事务所。她因在《BanG Dream! It\'s MyGO!!!!!》中为女主角高松灯配音而迅速走红，以清澈透明又略带沙哑的独特嗓音著称。',
  },
  {
    question: '为什么「羊宫妃那我来草你了」会流行起来？',
    answer: '该词条的流行与以下几个因素密切相关：《BanG Dream! It\'s MyGO!!!!!》动画的巨大成功、羊宫妃那出色的声音演绎引发的粉丝情感共鸣、中文二次元社区「扭曲的爱」文化传统，以及社交媒体平台的快速传播效应。',
  },
  {
    question: '这句话的来源是什么？',
    answer: '该词条最早出现在中国的弹幕视频网站和社交媒体平台。在MyGO!!!!!动画播出期间，粉丝们被羊宫妃那饰演的高松灯角色深深打动，产生了强烈的情感共鸣，从而催生了大量相关迷因。这句话从小众论坛开始传播，经由B站、微博等平台扩散，最终成为二次元圈层的标志性用语。',
  },
  {
    question: '什么是声优偶像化？',
    answer: '声优偶像化是指日本动画产业中声优从幕后走到台前的趋势。现代声优不仅需要配音能力，还需要具备偶像所需的外形条件、歌唱能力和舞台表现力。羊宫妃那在MyGO!!!!!乐队中的Live演出就是声优偶像化的典型案例。',
  },
  {
    question: '如何更好地了解二次元网络流行语？',
    answer: '建议关注本百科网站的分类内容，我们持续更新「网络流行语解读」和「网络用语来源」两个分类。同时推荐深入了解《BanG Dream! It\'s MyGO!!!!!》这部作品，它能帮助你更好地理解相关流行语的诞生语境和文化背景。',
  },
];

export default function Home() {
  return (
    <>
      <SEOHead
        title="首页"
        description="深度解析「羊宫妃那我来草你了」这一网络流行语的来源、语境与文化背景。围绕羊宫妃相关内容、羊宫妃词条解析、网络流行语解读、羊宫妃背景介绍，提供最全面的羊宫妃那百科知识，助你了解相关角色文化与网络用语来源。"
        keywords="羊宫妃那我来草你了,羊宫妃相关内容,羊宫妃词条解析,网络流行语解读,羊宫妃背景介绍,相关角色文化,网络用语来源"
        ogImage="https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20illustration%20of%20a%20voice%20actress%20recording%20studio%2C%20warm%20golden%20hour%20light%20streaming%20through%20windows%2C%20microphone%20and%20script%20on%20desk%2C%20artistic%20soft%20focus%2C%20elegant%20atmosphere%2C%20clean%20minimal%20background%2C%20pastel%20warm%20tones%2C%20cinematic%20composition&width=1600&height=900&seq=hero-bg-home&orientation=landscape"
        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '羊宫妃那词条百科 - 首页',
            description: '深度解析「羊宫妃那我来草你了」这一网络流行语的来源、语境与文化背景。',
            url: 'https://tjcongling.cn/',
            isPartOf: {
              '@type': 'WebSite',
              name: '羊宫妃那词条百科',
              url: 'https://tjcongling.cn',
            },
          },
          {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqItems.map((item) => ({
              '@type': 'Question',
              name: item.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: item.answer,
              },
            })),
          },
        ]}
      />

      <Navbar />

      <main>
        <section className="relative h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20illustration%20of%20a%20voice%20actress%20recording%20studio%2C%20warm%20golden%20hour%20light%20streaming%20through%20windows%2C%20microphone%20and%20script%20on%20desk%2C%20artistic%20soft%20focus%2C%20elegant%20atmosphere%2C%20clean%20minimal%20background%2C%20pastel%20warm%20tones%2C%20cinematic%20composition&width=1600&height=900&seq=hero-bg-home&orientation=landscape"
            alt="羊宫妃那词条百科 - 探索网络文化"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

          <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
            <h1
              className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-5 leading-tight"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              羊宫妃那词条百科
            </h1>
            <p className="text-lg md:text-xl text-white/80 mb-3 max-w-2xl mx-auto leading-relaxed">
              深度解析「羊宫妃那我来草你了」的来源、语境与文化背景
            </p>
            <p className="text-base text-white/60 mb-8 max-w-xl mx-auto">
              探索网络流行语的奥秘，理解当代二次元文化的独特魅力
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/article/yangongfei-wo-lai-cao-ni-le"
                className="px-8 py-3 bg-white text-foreground-950 rounded-full font-medium text-sm hover:bg-white/90 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                阅读核心词条
              </Link>
              <Link
                to="/category/yangongfei-analysis"
                className="px-8 py-3 border border-white/40 text-white rounded-full font-medium text-sm hover:bg-white/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                浏览分类
              </Link>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
                热门词条
              </h2>
              <p className="text-foreground-500 max-w-lg mx-auto">
                精选最受欢迎的词条解析文章，深入了解网络流行文化
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6">
              {featuredArticles.map((article) => (
                <ArticleCard
                  key={article.slug}
                  slug={article.slug}
                  title={article.title}
                  excerpt={article.excerpt}
                  coverImage={article.coverImage}
                  category={article.category}
                  categoryName={categoryMap[article.category] || article.category}
                  author={article.author}
                  publishDate={article.publishDate}
                  readTime={article.readTime}
                  tags={article.tags}
                />
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
                分类浏览
              </h2>
              <p className="text-foreground-500 max-w-lg mx-auto">
                按主题分类查找你感兴趣的内容
              </p>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group bg-white rounded-lg border border-foreground-100 p-5 text-center transition-all duration-300 hover:border-primary-300 hover:shadow-sm cursor-pointer"
                >
                  <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 group-hover:bg-accent-200 transition-colors">
                    <i className={`${cat.icon} text-xl`}></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-950 mb-1 whitespace-nowrap">
                    {cat.name}
                  </h3>
                  <p className="text-xs text-foreground-400 line-clamp-2">
                    {cat.description}
                  </p>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
                最新文章
              </h2>
              <p className="text-foreground-500 max-w-lg mx-auto">
                持续更新，为你带来最新的网络文化分析
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {recentArticles.map((article) => (
                <ArticleCard
                  key={article.slug}
                  slug={article.slug}
                  title={article.title}
                  excerpt={article.excerpt}
                  coverImage={article.coverImage}
                  category={article.category}
                  categoryName={categoryMap[article.category] || article.category}
                  author={article.author}
                  publishDate={article.publishDate}
                  readTime={article.readTime}
                  tags={article.tags}
                />
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
                常见问题
              </h2>
              <p className="text-foreground-500 max-w-lg mx-auto">
                关于「羊宫妃那我来草你了」及羊宫妃那相关词条的常见疑问
              </p>
            </div>
            <div className="space-y-4">
              {faqItems.map((item, index) => (
                <details
                  key={index}
                  className="group bg-white rounded-lg border border-foreground-100 overflow-hidden"
                >
                  <summary className="flex items-center justify-between px-6 py-4 cursor-pointer list-none">
                    <h3 className="text-base font-semibold text-foreground-950 pr-4">
                      {item.question}
                    </h3>
                    <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-foreground-100 text-foreground-500 group-open:bg-primary-100 group-open:text-primary-600 transition-colors">
                      <i className="ri-arrow-down-s-line text-sm group-open:rotate-180 transition-transform duration-200"></i>
                    </span>
                  </summary>
                  <div className="px-6 pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                </details>
              ))}
            </div>
            <div className="text-center mt-8">
              <Link
                to="/article/yangongfei-wo-lai-cao-ni-le"
                className="text-sm text-primary-500 hover:text-primary-600 transition-colors inline-flex items-center gap-1.5"
              >
                查看完整词条解析
                <i className="ri-arrow-right-line text-xs"></i>
              </Link>
            </div>
          </div>
        </section>

        <section className="py-16 md:py-24 bg-primary-500">
          <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
              和我们一起探索网络文化
            </h2>
            <p className="text-white/80 mb-8 text-base leading-relaxed">
              我们致力于用严谨的态度、通俗的语言，为每一位读者解读网络流行文化。无论是资深的二次元爱好者，还是刚刚入门的新人，都能在这里找到有价值的内容。
            </p>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-8 py-3 bg-white text-foreground-950 rounded-full font-medium text-sm hover:bg-white/90 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              了解更多
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}